import React from "react";

import { Stack, Typography } from "@mui/material";

/**
 * Provides the header for the dish.
 */
export const DishTitle = ({
  name,
  titleColor,
}: {
  name: string;
  titleColor?: string;
}) => {
  return (
    <Stack
      direction={"row"}
      sx={{
        display: "flex",
        alignItems: "center",
        // Lets the name wrap rather than hold the row open at its widest word.
        minWidth: 0,
      }}
    >
      <Typography
        noWrap
        variant="labelLMedium"
        sx={{
          color: titleColor,
          maxWidth: "100%",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          whiteSpace: "normal",
        }}
      >
        {name}
      </Typography>
    </Stack>
  );
};
